import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/company-groups'
const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function AddCompany(groupId, companyId) {
  return ApiRequest.post(
    `${BaseRoute}/${groupId}/addCompany?companyId=${companyId}`
  )
}

async function RemoveCompany(groupId, companyId) {
  const resp = await ApiRequest.delete(
    `${BaseRoute}/${groupId}/removeCompany?companyId=${companyId}`
  )
  return resp
}

const API = {
  ...baseFunctions,
  AddCompany,
  RemoveCompany,
}

export default API
